export default __webpack_public_path__ + "2472102aacb1eba311cff0f44e8707c0.svg";